"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React, { createRef } from "react";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";
import classNames from "classnames";
import { observer } from "mobx-react";
import { action, observable } from "mobx";
let TruncatedText = class extends React.Component {
  constructor() {
    super(...arguments);
    this.displayText = "";
    this.containerRef = createRef();
    this.originalTextRef = createRef();
    this.measureAvailableSpace = () => {
      var _a, _b;
      const text = this.props.children;
      const separator = "...";
      const containerWidth = (_a = this.containerRef.current) == null ? void 0 : _a.getBoundingClientRect().width;
      const originalTextWidth = (_b = this.originalTextRef.current) == null ? void 0 : _b.getBoundingClientRect().width;
      if (!!containerWidth && !!originalTextWidth && text.length > separator.length && originalTextWidth > containerWidth) {
        const avgCharSize = originalTextWidth / text.length;
        const maxLength = Math.floor(containerWidth / avgCharSize);
        const sliceStart = Math.ceil((maxLength - separator.length) / 2);
        const sliceEnd = text.length - sliceStart;
        this.displayText = `${text.slice(0, sliceStart)}${separator}${text.slice(sliceEnd, text.length)}`;
      } else {
        this.displayText = text;
      }
    };
  }
  componentDidMount() {
    this.measureAvailableSpace();
  }
  componentDidUpdate(prevProps) {
    if (this.props.children !== prevProps.children) {
      this.measureAvailableSpace();
    }
  }
  render() {
    const { className, children } = this.props;
    return /* @__PURE__ */ React.createElement(ReactResizeDetector, { handleWidth: true, handleHeight: false, onResize: this.measureAvailableSpace }, /* @__PURE__ */ React.createElement("div", { className: "truncated-text", ref: this.containerRef }, /* @__PURE__ */ React.createElement("div", { className: classNames("truncated-text__hidden-text", className), "aria-hidden": true, ref: this.originalTextRef }, children), /* @__PURE__ */ React.createElement("div", { className: classNames("truncated-text__ghost-text", className), "aria-hidden": true }, children), /* @__PURE__ */ React.createElement("div", { className: classNames("truncated-text__display-text", className) }, this.displayText)));
  }
};
__decorateClass([
  observable.ref
], TruncatedText.prototype, "displayText", 2);
__decorateClass([
  action
], TruncatedText.prototype, "measureAvailableSpace", 2);
TruncatedText = __decorateClass([
  observer
], TruncatedText);
export default TruncatedText;
